module.exports = __webpack_public_path__ + "img/role5.d439445e.jpg";